const FORM_FIELD = "form_field";
const BLOCK_ID = "amortization_calc";
const TOOLTIP = "tooltip";
export {
  BLOCK_ID,
  FORM_FIELD,
  TOOLTIP
};
